import { render, staticRenderFns } from "./User.Menu.ButtonBar.vue?vue&type=template&id=446ff456&scoped=true&"
import script from "./User.Menu.ButtonBar.vue?vue&type=script&lang=js&"
export * from "./User.Menu.ButtonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ff456",
  null
  
)

export default component.exports